/**
 * 全站通用的 Cookie/追踪同意门控（与具体第三方 SDK 无关）。
 *
 * 同意判定：getTrackingConsent() 为 yes，或 userCanBeTracked() 为 true（非 GDPR 等地区无需弹窗）。
 * 提供 whenConsented(fn)，在同意后才执行回调。
 *
 * 不负责加载任何第三方脚本。各 SDK 应订阅此层，例如 KlaviyoConsentLoader。
 *
 * @see KlaviyoConsentLoader — 在 consent 通过后加载 klaviyo.js，并提供 whenReady(fn) 等待 SDK 就绪
 */
class ConsentAppLoader {
  static _consented = null;
  static _queue = [];
  static _initialized = false;

  static init() {
    if (this._initialized) return;
    this._initialized = true;

    // Load the consent-tracking-api first, just like cookie-banner does
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{
        name: 'consent-tracking-api',
        version: '0.1',
        onLoad: () => this._onApiReady()
      }]);
    } else {
      // Fallback: listen for the event if Shopify API is unavailable
      document.addEventListener('trackingConsentAccepted', () => this._grant());
    }
  }

  static _onApiReady() {
    const api = window.Shopify?.customerPrivacy;
    if (!api) {
      document.addEventListener('trackingConsentAccepted', () => this._grant());
      return;
    }

    const consent = api.getTrackingConsent();
    if (api.userCanBeTracked() || consent === true || consent === 'yes') {
      this._grant();
      return;
    }

    // Not yet consented — listen for the event from cookie-banner
    document.addEventListener('trackingConsentAccepted', () => this._grant());
  }

  static _grant() {
    this._consented = true;
    this._queue.forEach((fn) => fn());
    this._queue = [];
  }

  static whenConsented(fn) {
    if (!this._initialized) this.init();

    if (this._consented) {
      fn();
      return;
    }
    this._queue.push(fn);
  }

  static isConsented() {
    return this._consented === true;
  }
}
